import React, {useState, useRef, useEffect} from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import dayjs from 'dayjs'
import {
  FiltersBar,
  RightControls,
  SearchWrapper,
  SearchIconWrap,
  SearchInput,
  ClearSearchBtn,
  DateRangeWrapper,
  DateRangeTrigger,
  CalendarPopout,
} from './styled.components'
import {PTCalender, PTCaretDown, PTSearch} from '../../../../assets'

function ProposalFilters({searchValue, onSearchChange, onDateRangeChange}) {
  const [isOpen, setIsOpen] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const wrapperRef = useRef(null)

  useEffect(() => {
    const handler = e => {
      if (
        isOpen &&
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target)
      ) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [isOpen])

  const handleClearDates = e => {
    e.stopPropagation()
    setStartDate('')
    setEndDate('')
    if (onDateRangeChange) onDateRangeChange('', '')
    setIsOpen(false)
  }

  const handleRangeChange = val => {
    if (Array.isArray(val)) {
      const [s, e] = val
      const newStart = s ? dayjs(s).format('YYYY-MM-DD') : ''
      const newEnd = e ? dayjs(e).format('YYYY-MM-DD') : ''
      setStartDate(newStart)
      setEndDate(newEnd)
      if (onDateRangeChange) onDateRangeChange(newStart, newEnd)
      if (s && e) setIsOpen(false)
    }
  }

  const getCalendarValue = () => {
    if (!startDate && !endDate) return null
    const toLocal = str => {
      if (!str) return null
      const [y, m, d] = str.split('-').map(Number)
      return new Date(y, m - 1, d)
    }
    return [toLocal(startDate), toLocal(endDate)]
  }

  const formatLabel = () => {
    if (!startDate && !endDate) return 'MM/DD/YY — MM/DD/YY'
    const fmt = str => (str ? dayjs(str).format('MM/DD/YY') : '—')
    return `${fmt(startDate)} — ${fmt(endDate)}`
  }

  return (
    <FiltersBar>
      <RightControls>
        <SearchWrapper>
          <SearchIconWrap>
            <img src={PTSearch} width="14" alt="Search" />
          </SearchIconWrap>
          <SearchInput
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={e => onSearchChange(e.target.value)}
          />
          {searchValue && (
            <ClearSearchBtn
              type="button"
              aria-label="Clear search"
              onClick={() => onSearchChange('')}
            >
              ×
            </ClearSearchBtn>
          )}
        </SearchWrapper>

        <DateRangeWrapper ref={wrapperRef}>
          <DateRangeTrigger
            type="button"
            hasValue={!!(startDate || endDate)}
            onClick={() => setIsOpen(o => !o)}
          >
            <img
              src={PTCalender}
              width="14"
              alt="Calendar"
              style={{filter: 'brightness(0) invert(0.5)', flexShrink: 0}}
            />
            <span style={{flex: 1, textAlign: 'center'}}>{formatLabel()}</span>
            {startDate || endDate ? (
              <span
                role="button"
                onClick={handleClearDates}
                style={{
                  fontSize: '16px',
                  lineHeight: 1,
                  flexShrink: 0,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                ×
              </span>
            ) : (
              <img
                src={PTCaretDown}
                width="10"
                alt=""
                style={{
                  filter: 'brightness(0) invert(0.5)',
                  flexShrink: 0,
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.15s ease',
                }}
              />
            )}
          </DateRangeTrigger>

          {isOpen && (
            <CalendarPopout>
              <Calendar
                selectRange
                onChange={handleRangeChange}
                value={getCalendarValue()}
              />
            </CalendarPopout>
          )}
        </DateRangeWrapper>
      </RightControls>
    </FiltersBar>
  )
}

export {ProposalFilters}
